import React, { useState } from 'react';
import { Routes, Route, Link, useLocation, useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import PropertiesPage from './PropertiesPage';
import SubscribersPage from './SubscribersPage';
import MessagesPage from './MessagesPage';

const AdminDashboard = () => {
  const { logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('properties');

  React.useEffect(() => {
    // Redirect to properties if at /admin root
    if (location.pathname === '/admin') {
      navigate('/admin/properties', { replace: true });
    }
    // Set active tab based on current route
    if (location.pathname.includes('/properties')) {
      setActiveTab('properties');
    } else if (location.pathname.includes('/subscribers')) {
      setActiveTab('subscribers');
    } else if (location.pathname.includes('/messages')) {
      setActiveTab('messages');
    }
  }, [location, navigate]);

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const tabs = [
    { id: 'properties', label: 'Properties', path: '/admin/properties' },
    { id: 'subscribers', label: 'Subscribers', path: '/admin/subscribers' },
    { id: 'messages', label: 'Messages', path: '/admin/messages' },
  ];

  return (
    <div className="min-h-screen bg-[#E9E7F4]">
      {/* Header */}
      <div className="bg-[#03002F] text-white px-4 md:px-8 py-6">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <h1 className="text-2xl md:text-3xl font-bold font-cabinet">Admin Dashboard</h1>
          <button
            onClick={handleLogout}
            className="bg-[#5F5CF0] hover:bg-[#4d4bd6] text-white font-satoshi font-bold px-6 py-2 rounded-[8px] transition-colors"
          >
            Logout
          </button>
        </div>
      </div>

      {/* Tabs */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex space-x-1">
            {tabs.map((tab) => (
              <Link
                key={tab.id}
                to={tab.path}
                className={`px-6 py-4 font-satoshi font-bold text-base transition-colors ${
                  activeTab === tab.id
                    ? 'text-[#5F5CF0] border-b-2 border-[#5F5CF0]'
                    : 'text-[#282727] hover:text-[#5F5CF0]'
                }`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-8">
        <Routes>
          <Route path="properties" element={<PropertiesPage />} />
          <Route path="subscribers" element={<SubscribersPage />} />
          <Route path="messages" element={<MessagesPage />} />
          <Route path="" element={<Navigate to="/admin/properties" replace />} />
          <Route path="*" element={<Navigate to="/admin/properties" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default AdminDashboard;

